export default {
  path: '/history',
  name: 'History',
  component: () => import('../views/layouts/History.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'empInfo/:guid',
      name: 'HistoryEmpInfo',
      component: () => import('../views/pages/History/HistoryEmpInfo.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empaddress/:guid',
      name: 'HistoryEmpAddress',
      component: () =>
        import('../views/pages/History/HistoryEmpAddress.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empfamily/:guid',
      name: 'HistoryEmpFamilies',
      component: () =>
        import('../views/pages/History/HistoryEmpFamilies.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empwork/:guid',
      name: 'HistoryEmpWorks',
      component: () =>
        import('../views/pages/History/HistoryEmpWorks.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empedu/:guid',
      name: 'HistoryEmpEducation',
      component: () =>
        import('../views/pages/History/HistoryEmpEducation.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empfame/:guid',
      name: 'HistoryEmpFames',
      component: () =>
        import('../views/pages/History/HistoryEmpFames.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empleave/:guid',
      name: 'HistoryEmpLeave',
      component: () =>
        import('../views/pages/History/HistoryEmpLeave.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empleaveedu/:guid',
      name: 'HistoryEmpLeaveEdu',
      component: () =>
        import('../views/pages/History/HistoryEmpLeaveEdu.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empexecutive/:guid',
      name: 'HistoryEmpExecutives',
      component: () =>
        import('../views/pages/History/HistoryEmpExecutives.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'emptechnical/:guid',
      name: 'HistoryEmpTechnicalskills',
      component: () =>
        import('../views/pages/History/HistoryEmpTechnicalskills.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'emptraining/:guid',
      name: 'HistoryEmpTraining',
      component: () =>
        import('../views/pages/History/HistoryEmpTraining.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'committees/:guid',
      name: 'Historycommittees',
      component: () =>
        import('../views/pages/History/Historycommittees.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'publicservice/:guid',
      name: 'HistoryPublicservices',
      component: () =>
        import('../views/pages/History/HistoryEmpPublicservice.page.vue'),

      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empartculture/:guid',
      name: 'HistoryEmpArtcultures',
      component: () =>
        import('../views/pages/History/HistoryEmpArtcultures.page.vue'),

      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empletraining/:guid',
      name: 'HistoryLifeLong',
      component: () =>
        import('../views/pages/History/HistoryLifeLong.page.vue'),

      meta: {
        requiresAuth: true
      }
    }
  ]
}
